import Zoom from "../../Components/Zoom/Zoom";

const Templates = {

    init() {
        this.el = $('[component="Thumbs"]');
        if (!this.el.length) return;
        this.template = this.el.attr('template');

        this.thumbs = this.el.find('.thumb');
        this.bind();
        Zoom.init(this.el, this.onZoom);
        // this.resize();
    },

    onZoom(val){
        Templates.el.attr('zoom', val);
        setTimeout(() => {
            Templates.resize();
        }, 300)
    },

    bind() {
        this.thumbs.click((evt) => {
            window.location.href = '/' + $(evt.currentTarget).attr('url');
        })
    },

    resize() {
        if (!this.thumbs) return;
        this.thumbs.each((i, el) => {

            let cssScale = 1;

            switch (Zoom.value) {
                case "1":
                    cssScale = 1;
                    break;
                case "2":
                    cssScale = 3;
                    break;
                case "3":
                    cssScale = 5;
                    break;
                case "4":
                    cssScale = 8;
                    break;
                case "5":
                    cssScale = 8;
                    break;
            }

            let height = $(el).find('main').outerHeight() / cssScale;
            const maxHeight = $(el).find('main').outerWidth() / cssScale;
            const padding = parseInt($(el).css('paddingLeft'));
            const headerHeight = $(el).find('header').outerHeight();
            const bulgarianConstant = 4;

            height = height + (2 * padding) + headerHeight + bulgarianConstant;
            height = this.template === 'masonry' ? height : maxHeight;

            $(el).css({height: height})
        })
    },
};

export default Templates;